import CommonDataService from "../../service/CommonDataService";
import { setNotificationData } from "./uiActions";

export const OKTA_USER_INFO = 'OKTA_USER_INFO';
export const SET_MARKET_LANGUAGES = 'SET_MARKET_LANGUAGES';
export const SET_MARKET_LANGUAGES_LOADER = 'SET_MARKET_LANGUAGES_LOADER';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_COUNTRIES_LOADER = 'SET_COUNTRIES_LOADER';
export const SET_COUNTRIES_ERROR = 'SET_COUNTRIES_ERROR';

export const setOktaUserInfo = (options) => {
  return {
    type: OKTA_USER_INFO,
    payload: options,
  };
};

export const setMarketLanguages = (options) => {
  return {
    type: SET_MARKET_LANGUAGES,
    payload: options,
  };
}

export const setMarketLanguagesLoader = (options) => {
  return {
    type: SET_MARKET_LANGUAGES_LOADER,
    payload: options,
  };
}

export const setCountries = (options) => {
  return {
    type: SET_COUNTRIES,
    payload: options,
  };
}

export const setCountriesLoader = (options) => {
  return {
    type: SET_COUNTRIES_LOADER,
    payload: options,
  };
}

export const setCountriesError = (options) => {
  return {
    type: SET_COUNTRIES_ERROR,
    payload: options,
  };
}

export const fetchMarketLanguages = (history, redirect) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const prevURL = state.uiState?.lastVisitedUrl || '/dashboard';

      dispatch(setMarketLanguagesLoader(true));

      const response = await CommonDataService.getMarketLanguages();
      if (response?.data) {
        dispatch(setMarketLanguages(response?.data));

        if (redirect != 'false') {
          history.push(prevURL);
        }
      } else {
        dispatch(setMarketLanguages([]));
        localStorage.clear();
        dispatch(
        setNotificationData({
          show: true,
          type: 'WARNING',
          title: 'Failed to fetch market languages',
          description: ``,
        }),
      );
      }
    } catch (error) {
      console.log('error', error);
      dispatch(setMarketLanguages([]));
      dispatch(
        setNotificationData({
          show: true,
          type: 'WARNING',
          title: 'Failed to fetch market languages',
          description: ``,
        }),
      );
    } finally {
      dispatch(setMarketLanguagesLoader(false));
    }
  };
};

export const fetchCountries = () => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { countries } = state.commonData || {};

      // Commented to fix the segmentation issue. After changing the segment we need to fetch the new list of countries
      // if (countries && countries.length > 0) {
      //   return;
      // }

      dispatch(setCountriesLoader(true));
      dispatch(setCountriesError(null));

      const response = await CommonDataService.getCountries();

      if (response?.data) {
        const countriesArray = Object.entries(response.data)
          .map(([countryName, countryCode]) => ({
            countryName,
            countryCode,
            checked: false,
          }))
          .sort((a, b) => (a.countryName > b.countryName ? 1 : -1));
        dispatch(setCountries(countriesArray));
      } else {
        dispatch(setCountries([]));
        dispatch(setCountriesError('Failed to fetch countries'));
        dispatch(
          setNotificationData({
            show: true,
            type: 'WARNING',
            title: 'Failed to fetch countries',
            description: ``,
          }),
        );
      }

    } catch (error) {
      console.log('error fetching countries', error);
      dispatch(setCountries([]));
      dispatch(setCountriesError(error.message || 'Failed to fetch countries'));
      dispatch(
        setNotificationData({
          show: true,
          type: 'WARNING',
          title: 'Failed to fetch countries',
          description: ``,
        }),
      );
    } finally {
      dispatch(setCountriesLoader(false));
    }
  };
};
